import toast from 'react-hot-toast';
import { utils } from '@/utils';
import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { operationRequirement, type OperationContext } from '@/session/operation';

const validate = (modelName: string, id: number) => {
  if (!modelName) {
    throw new Error('Model name is required');
  }
  if (id == null) {
    throw new Error('Import ID is required');
  }
};

export type RequestParams = {
  modelName: string;
  id: number;
};

export const downloadErrorReport = async (scope: RequestScope, { modelName, id }: RequestParams, operation: OperationContext) => {
  try {
    validate(modelName, id);
    if (typeof window === 'undefined') return;
    if (!operation.isScopeCurrent()) return;

    const url = `download/error_report/${encodeURIComponent(modelName)}/${id}`;
    const response = await scopedApi(scope).get<Blob>(url, {
      responseType: 'blob',
      operationRequirement: operationRequirement(operation, 'scope'),
    });
    if (!operation.isScopeCurrent()) return;

    const fileName = `${modelName}_import_${id}_errors.csv`;

    const blob = new Blob([response.data]);
    if (!operation.isScopeCurrent()) return;
    const fileURL = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = fileURL;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(fileURL);
  } catch (e) {
    const result = utils.error.handleAxiosError(e);
    if (operation.isScopeCurrent() && !utils.error.isCanceledResponse(result)) toast.error('Error Downloading Error Report');
    return result;
  }
};
